import React, { useEffect, useState } from "react"
import { CustomButton, SectionHeader } from "../GlobalComponents/CommonComponents"
import CustomAccordion from "../GlobalComponents/CustomAccordion"
import { FormField } from "../GlobalComponents/Fields"
import "./index.css"
// import Textarea from './TextArea';
import UserRegistrationModal from "./UserRegistrationModal"
import { getUsersByRole } from "../../services/userServices"
import { Box } from "@mui/material"
import { getFullName } from "../../utils/Helpers"

const GPDetailsSection = (props) => {
  const {
    formData,
    handleChange,
    options,
    activeModal,
    setActiveModal,
    onCloseModal,
  } = props.data
  let modalData = {}
  const [selectedGP, setSelectedGP] = useState(null)

  if (activeModal === "GPModal") {
    modalData = {
      // ...modalData,
      onClose: onCloseModal,
      onSubmit: onSubmit,

      title: "Add New GP",
      show: true,
      formData: {
        role: "GP",
        disabledRole: true,
      },
    }
  }

  useEffect(() => {
    getUsers(formData?.gp)
  }, [])

  const [gpData, setGPData] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (selectedGP && formData.gp !== selectedGP) {
      handleChange({ target: { name: "gp", value: selectedGP } })
    }
  }, [selectedGP])

  async function getUsers(id = "") {
    try {
      const gpResult = await getUsersByRole({ role: "GP" })
      console.log("onnasdfsadf gpResult--23 Gp", gpResult, formData)
      setIsLoading(false)

      if (gpResult?.userDetails) {
        const newGPData = gpResult?.userDetails?.map((each) => {
          if (each?._id === id) {
            console.log("onnasdfsadf", id, each)
            setSelectedGP(each)
            handleChange({ target: { name: "gp", value: each } })
            // const { name, value } = e.target;
          }
          let label = getFullName(each)

          return { ...each, label, value: each }
        })

        setGPData(newGPData)
      } else {
        setGPData([])
      }
    } catch (error) {
      setGPData([])
    }

    setIsLoading(false)
  }

  function onSubmit(data) {
    console.log("onnasdfsadf", data)
    const id = data?.result?.userDetails?._id
    getUsers(id)

    onCloseModal()
  }

  function handleGPChange(e) {
    console.log("handleGPChange", e.target.value)
    const { name, value } = e.target
    setSelectedGP(e.target.value)
    handleChange(e)
  }

  console.log("selectedGP123", { selectedGP, formData })
  return (
    // <CustomAccordion title="GP Details">
    <Box
      style={{
        border: "0px solid blue",
        flex: 1,
        width: "100%",
        borderRadius: "5px",
      }}
    >
      <SectionHeader title="GP Details" />

      <Box className="patient-form-fields-container">
        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          type="dropdown"
          label="GP"
          options={gpData}
          name="gp"
          value={selectedGP}
          // value={formData.gp}
          onChange={handleGPChange}
          placeholder="GP"
        />

        <CustomButton
          text="Add new GP"
          onClick={() => {
            setActiveModal("GPModal")
          }}
        />

        {modalData.show && <UserRegistrationModal {...modalData} />}
      </Box>
    </Box>
  )
}

export default GPDetailsSection
